"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumbs = void 0;
var _themeGet = require("@styled-system/theme-get");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _flattenChildren = require("../../helpers/flattenChildren");
var _Box = require("../Box");
var _Flex = require("../Flex");
var _Join = require("../Join");
var _Text = require("../Text");
var _excluded = ["children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Li = (0, _styledComponents.default)(_Text.Text).withConfig({
  displayName: "Breadcrumbs__Li",
  componentId: "sc-1ve5xfq-0"
})(["> a{color:", ";text-decoration:none;&:hover{color:", ";text-decoration:underline;}}&:last-of-type{> a{color:", ";&:hover{color:", ";text-decoration:none;}}}"], (0, _themeGet.themeGet)("colors.black60"), (0, _themeGet.themeGet)("colors.blue100"), (0, _themeGet.themeGet)("colors.black100"), (0, _themeGet.themeGet)("colors.black100"));

/** Breadcrumbs extends Box */

/**
 * A breadcrumb trail consists of a list of links to the parent pages of the
 * current page in hierarchical order. It helps users find their place within
 * a website or web application. Breadcrumbs are often placed horizontally
 * before a page's main content.
 */
var Breadcrumbs = function Breadcrumbs(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var cells = (0, _flattenChildren.flattenChildren)(children);
  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    as: "nav",
    "aria-label": "Breadcrumb"
  }, rest), /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    as: "ol"
  }, /*#__PURE__*/_react.default.createElement(_Join.Join, {
    separator: /*#__PURE__*/_react.default.createElement(_Text.Text, {
      as: "span",
      size: "xs",
      color: "black60",
      mx: 1,
      "aria-hidden": "true"
    }, "/")
  }, cells.map(function (cell, i) {
    return /*#__PURE__*/_react.default.createElement(Li, {
      as: "li",
      size: "xs",
      key: i
    }, i === cells.length - 1 ? /*#__PURE__*/_react.default.cloneElement(cell, {
      "aria-current": "page"
    }) : cell);
  }))));
};
exports.Breadcrumbs = Breadcrumbs;
Breadcrumbs.displayName = "Breadcrumbs";
//# sourceMappingURL=Breadcrumbs.js.map